import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 竞价采购路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @param listRoute
 * @param needIcon
 * @returns <Object> route
 */
export default function generateCompeteRoutes(
  modulePath = 'compete',
  prefix = '',
  sideMenuTitle = '竞价采购',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right],
  listRoute = {},
  needIcon = true
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: needIcon ? 'icon-side_purchase_compete' : '',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 项目列表
      Object.assign(
        {},
        {
          path: 'list',
          name: `${prefix}CompeteManage`,
          component: '/procure-views/compete/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '项目列表',
            cache: true,
            hidden: true,
            pageComponentName: 'CompeteManage'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities,
          roles: [
            ...roles,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        listRoute
      ),

      // 新增竞价单
      {
        path: 'order/:orderId?/projects/:projectId?/create-compete/:isCopy?',
        name: `${prefix}CreateCompete`,
        component: '/procure-views/compete/create-compete/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '新增竞价单',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 项目预览
      {
        path: 'order/:orderId?/projects/:projectId?/compete/publish/preview',
        name: `${prefix}CreateCompetePreview`,
        component: '/procure-views/compete/create-compete/preview',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '项目预览',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 竞价单详情
      {
        path: 'order/:orderId/detail',
        name: `${prefix}CompeteDetail`,
        component: '/procure-views/compete/process/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '竞价单详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名情况
      {
        path: 'order/:orderId/sign-up-situation',
        name: `${prefix}SignUpSituation`,
        component: '/procure-views/compete/process/sign-up-situation',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名情况',
          cache: true,
          hidden: true,
          pageComponentName: 'SignUpSituation'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 报名详情
      {
        path: 'sign-up-situation/order/:orderId/trade/:tradeId/:method',
        name: `${prefix}SignUpDetail`,
        component: '/procure-views/compete/process/sign-up-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '报名详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 邀请详情
      {
        path: 'sign-up-situation/order/:orderId/invite/:inviteId/detail',
        name: `${prefix}InviteDetail`,
        component: '/procure-views/compete/process/invite-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '邀请详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 价格谈判
      {
        path: 'order/:orderId/price-negotiation',
        name: `${prefix}PriceNegotiation`,
        component: '/procure-views/compete/process/price-negotiation/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '价格谈判',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 成交公示
      {
        path: 'order/:orderId/public-notice',
        name: `${prefix}CompetePublicNotice`,
        component: '/procure-views/compete/process/public-notice/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '成交公示',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 进入竞价大厅
      {
        path: 'order/:orderId/hall-door',
        name: `${prefix}CompeteHallDoor`,
        component: '/procure-views/compete/process/compete-hall-door',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '进入竞价大厅',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 竞价大厅
      {
        path: 'order/:orderId/hall/:token',
        name: `${prefix}CompeteHall`,
        component: '/procure-views/compete/process/compete-hall',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '竞价大厅',
          layout: 'NoLayout',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 信息变更
      {
        path: 'order/:orderId/info-change',
        name: `${prefix}CompeteInfoChange`,
        component: '/procure-views/compete/process/compete-info-change',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '信息变更',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更公告
      {
        path: 'order/:orderId/info-change-detail',
        name: `${prefix}CompeteChangeNewestDetail`,
        component: '/procure-views/compete/process/compete-info-change-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更公告',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 答疑澄清
      {
        path: 'order/:orderId/clarification',
        name: `${prefix}CompeteClarificationFile`,
        component: '/procure-views/compete/process/clarification-file',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '答疑澄清',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 追加供应商
      {
        path: 'order/:orderId/abnormal/add-supplier',
        name: `${prefix}AddSupplier`,
        component: '/procure-views/compete/abnormal/add-supplier',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '追加供应商',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标处理
      {
        path: 'order/:orderId/abnormal/aborted',
        name: `${prefix}AbortedCompete`,
        component: '/procure-views/compete/abnormal/aborted-compete',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标处理',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标详情
      {
        path: 'order/:orderId/abnormal/aborted-detail',
        name: `${prefix}AbortedCompeteNewestDetail`,
        component: '/procure-views/compete/abnormal/aborted-compete-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      }
    ]
  }
}
